import {
  DELETE_FILE_REFERENCE_REQUEST,
  deleteFileReferenceSuccess,
  deleteFileReferenceFailure,
  showSuccessNotification
}                               from 'Redux/Action';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';

export const deleteFileReferenceEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
  return action$.pipe(
    ofType(DELETE_FILE_REFERENCE_REQUEST),
    mergeMap(action => from(FileReferenceRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          return from([
            showSuccessNotification(`Das Datei wurde erfolgreich gelöscht.`),
            deleteFileReferenceSuccess(action.payload.id),
          ]);
        }),
        catchError(error => {
          return from([
            deleteFileReferenceFailure(error),
          ]);
        })
      )
    ),
  );
};
